/* Import Font Awesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* Import specific icons */
import { 
  faUser,
  faHome,
  faUsers,
  faArrowLeft,
  faCalendarAlt,
  faTag,
  faCalendar,
  faEnvelope,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faMountainSun,
  faPhone,
  faBed,
  faTree,
  faUserTie,
  faHouseChimneyWindow,
  faPlus,
  faMinus,
  faMapMarkerAlt,
  faTimes,
  faBars
} from '@fortawesome/free-solid-svg-icons'

/* Add icons to the library */
library.add(
  faUser,
  faHome,
  faUsers,
  faArrowLeft,
  faCalendarAlt,
  faTag,
  faCalendar,
  faEnvelope,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faMountainSun,
  faPhone,
  faBed,
  faTree,
  faUserTie,
  faHouseChimneyWindow,
  faPlus,
  faMinus,
  faMapMarkerAlt,
  faTimes,
  faBars
)

export { FontAwesomeIcon }